import Card from './Card'

export { Card }
export default Card
